module.exports = __webpack_public_path__ + "img/texto-galeria-mobile.b0c60648.png";